module.exports = __webpack_public_path__ + "assets/img/wljg.bd2b9f7b.png";